module.exports = __webpack_public_path__ + "static/media/logo-primary.d3763ce2.svg";